import moment from "moment";
import { ICustomReactSelectOption } from "../core/types/elements/ICustomReactSelectOption";
import ExpensesTypes from "../core/types/enums/ExpensesEnum";

const watchingAppointmentKey: string[] = ["startTime", "endTime", "techIds"];

/**
 * Expenses captured as a start/end time range rather than a quantity.
 * They share one form, one payload shape and one card layout, so this list is
 * the single source of truth for "is this expense a stretch of time?".
 */
const timeRangeExpenseTypes: readonly ExpensesTypes[] = [
  ExpensesTypes.Travel,
  ExpensesTypes.Labor,
  ExpensesTypes.LaborOT,
  ExpensesTypes.Shop,
];

const expenseDefaultForm = {
  quantity: undefined,
  price: undefined,
  description: "",
  startMileage: undefined,
  endMileage: undefined,
  item: undefined,
  type: undefined,
  startTime: undefined,
  endTime: undefined,
};

const defaultTime = "00:00:00";
const today = new Date();
const endTime = moment(today).add(1, "hour").toDate();
const curremntAppointmentConst = {
  title: "New Appointment",
  startTime: new Date(),
  endTime: new Date(),
  active: true,
};
const defaultItemExpense = {
  label: "Default Config",
  value: "0",
};

const quoteWOStatuses: ICustomReactSelectOption = { label: "Without WO", value: "0" };

export {
  expenseDefaultForm,
  watchingAppointmentKey,
  defaultTime,
  today,
  endTime,
  timeRangeExpenseTypes,
  curremntAppointmentConst,
  defaultItemExpense,
  quoteWOStatuses,
};
